<h1 mat-dialog-title>
  <span class="d-inline-block w-50">Project Settings</span>
  <span class="d-inline-block w-50">Extensions</span>
</h1>
<div mat-dialog-content>
  <app-project-settings [project]="project" />
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Close</button>
</div>